var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"HomeView"}},[_c('TheNavbar'),_c('BannerSection'),_c('AboutSection'),_c('FeaturesSection'),_c('BenefitsSection'),_c('ContactSection'),_c('TheFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }